// FILE: /src/Components/ShowProfiles.js (FULLY UPDATED)

import { Tooltip, Checkbox } from "antd";
import Images from "../Comman Components/Images";
import PinImage from "../Comman Components/Pinterest Componets/PinImage";
import PinName from "../Comman Components/Pinterest Componets/PinName";
import UserName from "../Comman Components/UserName";

function ShowProfiles({ avalibaleProfile, CheckPlatform, ChangePlatform, validationErrors }) {
    // --- START: MODIFICATION ---
    const supportedPlatforms = ["FACEBOOK", "INSTAGRAM", "PINTEREST", "LINKEDIN", "GMB", "YOUTUBE", "TIKTOK"];
    // --- END: MODIFICATION ---
    
    return (
        avalibaleProfile
            .filter(profile => supportedPlatforms.includes(profile.platform))
            .map((elem, index) => {
                const uniqueKey = `${elem.platform}-${elem.platform_pageId || elem.platform_id}-${index}`;
                const key = elem.platform === 'FACEBOOK' ? elem.platform_pageId : elem.platform_id;
                const error = validationErrors[key];
                const isDisabled = !!error;

                const profileContent = (
                    <div className={`flex items-center justify-between py-2 px-3 rounded-lg ${isDisabled ? 'opacity-50 bg-gray-100' : 'hover:bg-gray-50'}`}>
                        <div className="flex items-center w-full gap-3">
                            {renderProfileImage(elem)}
                            {renderPlatformIcon(elem.platform)}
                            {renderProfileName(elem)}
                        </div>
                        <Checkbox
                            checked={!isDisabled && CheckPlatform(elem)}
                            onChange={(e) => ChangePlatform(elem, e.target.checked)}
                            disabled={isDisabled}
                        />
                    </div>
                );

                return (
                    <li key={uniqueKey}>
                        {isDisabled ? (
                            <Tooltip title={error} placement="left">
                                {profileContent}
                            </Tooltip>
                        ) : (
                            profileContent
                        )}
                    </li>
                );
            })
    );
}

export const renderProfileImage = (elem) => {
    switch (elem.platform) {
        case "FACEBOOK":
            return <img src={`https://graph.facebook.com/${elem.platform_pageId}/picture?return_ssl_resources=true`} alt='profile' className="w-8 h-8 rounded-full" />;
        case "INSTAGRAM":
            return  <Images Id={elem.user_id || elem.platform_id } />;
        case "PINTEREST":
            return <PinImage Id={elem.platform_id} />;
        case "LINKEDIN":
            return <Images Id={elem.user_id || elem.platform_id} />;
        case "GMB":
            return (
                <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                    <i className="fa-solid fa-store text-blue-600"></i>
                </div>
            );

        case "YOUTUBE":
            return <Images Id={elem.user_id || elem.platform_id} />;
        
        case "TIKTOK":
            return <Images Id={elem.user_id || elem.platform_id} />;    

        default:
            return <div className="w-8 h-8 rounded-full bg-gray-200" />;

            
    }
};

export const renderPlatformIcon = (platform) => {
    const icons = {
        FACEBOOK: { class: "fa-facebook", color: "#1877F2" },
        INSTAGRAM: { class: "fa-instagram", color: "#E1306C" },
        PINTEREST: { class: "fa-pinterest", color: "#E60023" },
        LINKEDIN: { class: "fa-linkedin", color: "#0A66C2" },
        GMB: { class: "fa-google", color: "#4285F4" },
        YOUTUBE: { class: "fa-youtube", color: "#FF0000" },
        TIKTOK: { class: "fa-tiktok", color: "#000000" },
    };
    if (icons[platform]) {
        return <i className={`fa-brands ${icons[platform].class} text-lg`} style={{ color: icons[platform].color }}></i>;
    }
    return null;
};

export const renderProfileName = (elem) => {
    switch (elem.platform) {
        case "FACEBOOK":
            return <span className='font-semibold text-sm'>{elem.profile}</span>;
        case "INSTAGRAM":
            return <UserName Id={elem.user_id || elem.platform_id} />;
        case "PINTEREST":
            return <PinName Id={elem.platform_id} />;
        case "LINKEDIN":
             return <UserName Id={elem.user_id || elem.platform_id} />;
        case "GMB":
            return <span className='font-semibold text-sm'>{elem.profile}</span>;

        case "YOUTUBE":
            return <UserName Id={elem.user_id || elem.platform_id} />;

        case "TIKTOK":
            return <UserName Id={elem.user_id || elem.platform_id} />;           

        default:
            return null;
    }
};

export default ShowProfiles;